import React from 'react'
import Navbar from '../components/Navbar'
import Products from '../components/Products'

function ProductsPage() {
  return (
    <div>
      <Navbar/>
      <Products/>
    </div>
  )
}

export default ProductsPage